// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2uZ4y","icon":"SortAdornment_icon__39xsp","up":"SortAdornment_up__1ctbv","down":"SortAdornment_down__2s671","active":"SortAdornment_active__1Rplp"};